/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { Departement, Pays } from '@/types';

type AdresseStoreType = {
  pays: Pays[];
  setPays: (pays: Pays[]) => void;
  departements: Departement[];
  setDepartements: (departements: Departement[]) => void;
};

const useAdresseStore = create<AdresseStoreType>()(
  devtools((set) => ({
    pays: null,
    setPays: (pays) => set({ pays }),
    departements: null,
    setDepartements: (departements) => set({ departements }),
  })),
);

export default useAdresseStore;
